import { render, staticRenderFns } from "./DeliveryLoads.vue?vue&type=template&id=3d7628b4&scoped=true&"
import script from "./DeliveryLoads.vue?vue&type=script&lang=js&"
export * from "./DeliveryLoads.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryLoads.vue?vue&type=style&index=0&id=3d7628b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7628b4",
  null
  
)

export default component.exports